// this component was automatically generated by IconGlyph.template.js
import React from 'react';
import { TestId } from '@trello/test-ids';

import { Icon, IconColor, IconSize } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon. Usually it
   * matches up with the display name of the icon
   * @default If no label is provided, it will fallback to the name of the icon
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default @icon-default-color (#42526E)
   */
  color?: IconColor;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-test-id) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
}

const PowerUpIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.5 2.655c.997-.11 2.035.152 2.864.981L18.95 5.05c-.33-.33-.735-.467-1.24-.411-.55.06-1.214.323-1.961.746-.737.417-1.477.944-2.181 1.46l-.32.235c-.568.42-1.131.835-1.593 1.109-.494.293-1.019.28-1.335.25-.332-.034-1.12-.042-2.376.38-.778.26-1.728.88-2.538 1.499l-.062.047c.247.052.507.1.769.143a29.181 29.181 0 001.916.247l.03.003h.008l.899 1.102v.006l-.003.022a10.071 10.071 0 00-.039.44c-.021.294-.043.688-.044 1.098 0 .416.02.818.073 1.137.037.225.078.333.092.37l.005.017a.1.1 0 00.016.005c.038.014.146.055.371.092.32.053.72.073 1.137.072.41 0 .804-.022 1.097-.043l.468-.042 1.102.899.063.591c.042.365.105.855.188 1.363.043.262.091.522.143.77l.047-.063c.618-.81 1.239-1.76 1.5-2.538.42-1.255.413-2.044.38-2.376-.032-.316-.044-.84.25-1.335.273-.462.688-1.024 1.108-1.594l.235-.319c.517-.704 1.043-1.444 1.46-2.18.423-.748.686-1.411.746-1.963.056-.504-.08-.908-.411-1.239l1.414-1.414c.829.829 1.09 1.867.98 2.863-.104.95-.52 1.892-.994 2.73-.48.848-1.068 1.671-1.588 2.38l-.255.346c-.412.56-.745 1.012-.963 1.373a.747.747 0 00.004.145c.062.627.032 1.7-.474 3.21-.372 1.11-1.168 2.28-1.807 3.117a22.826 22.826 0 01-1.213 1.456l-.027.03-.003.003a.994.994 0 01-1.435.028 2.305 2.305 0 01-.453-.7 5.743 5.743 0 01-.26-.745 15.5 15.5 0 01-.353-1.652c-.066-.405-.12-.795-.162-1.126-.241.012-.511.02-.792.021-.465.001-.99-.02-1.464-.098-.413-.068-1.052-.237-1.469-.653-.416-.417-.585-1.056-.653-1.469a9.188 9.188 0 01-.098-1.464c0-.28.01-.55.021-.792a30.003 30.003 0 01-1.126-.162 15.5 15.5 0 01-1.652-.352 5.74 5.74 0 01-.746-.261 2.306 2.306 0 01-.699-.453.994.994 0 01-.29-.722c.005-.27.12-.528.318-.713l.003-.003.007-.006.023-.021a12.449 12.449 0 01.393-.35c.262-.225.63-.533 1.063-.863.838-.64 2.008-1.435 3.117-1.806 1.51-.507 2.583-.537 3.21-.475.074.008.12.007.145.004.361-.217.813-.55 1.373-.963l.347-.255c.708-.52 1.53-1.108 2.38-1.588.837-.474 1.78-.89 2.729-.995z"
        fill="currentColor"
      />
      <path
        d="M15.414 8.586a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PowerUpIcon: React.FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label } = props;
  return (
    <Icon
      testId={testId}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      label={label || 'PowerUpIcon'}
      glyph={PowerUpIconGlyph}
    />
  );
};
